import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import { Fade, Slide } from "react-awesome-reveal";
import { isMobileDevice } from '../../utils';
import { useEffect, useState } from 'react';
import { addCart, productRecommended } from '../../API';
import { useNavigate } from 'react-router';
import { message } from 'antd';

interface PaginationProps {
  productList?: any;
}

const Home: React.FC<PaginationProps> = ({
  productList,
}) => {  
  const [swiperRef, setSwiperRef]: any = useState(null);
  const [swiperIndex, setSwiperIndex] = useState(0);
  const [productLi, setProductLi]: any = useState([])

  const handleLoad = () => {
    if (!!productList) {
      setProductLi(productList)
    } else {
      productRecommended().then((res: any) => {
        setProductLi(res.data)
      })
    }
  }
  useEffect(() => {
    handleLoad() 
  }, [productList])
  const navigate = useNavigate()


  const handleaddCart = (item: any) => {
    addCart({
      productId: item?.id,
      productNum: 1
    }).then((res: any) => {
      console.log(res)
      message.success('加入購物車成功')
    }).catch((err: any) => {
      console.log(err)
    })
  }

  return (
    <div className=' '> 
      <div className='w-[930px] mx-auto relative mt-[30px] h5:w-full'>
        <Swiper
          slidesPerView={isMobileDevice() ? 1 : 4}
          autoplay={{
            delay: 100000,
            // disableOnInteraction: false,
          }}
          spaceBetween={26}
          loop={false} 
          modules={[Autoplay, Pagination]}
          pagination={{
            clickable: true,  // 使指示点可点击
            bulletClass: 'swiper-pagination-bullet3',  // 指示点的类名
            bulletActiveClass: 'swiper-pagination-bullet-active3',  // 活动指示点的类名
          }}
          ref={swiperRef}
          onSwiper={setSwiperRef}
          onSlideChange={(swiper: any) => {
            setSwiperIndex(swiper.activeIndex);
          }}
        >
          {
            productLi && productLi.map((item: any, index: number) => (
              <SwiperSlide key={index}>
                <Fade cascade={true} direction="down" delay={0} duration={600} triggerOnce={true}>
                  <div className="pb-[80px] cursor-pointer h5:px-[60px]"
                    onClick={() => {
                      navigate(`/product?id=${item?.id}&category=${'精選商品'}`)
                    }}
                  >
                    <div className="p-[15px] rounded-[4px]"
                      style={{
                        border: "1px solid rgba(0, 0, 0, .1)"
                      }}>
                      <img src={item?.detailImageUrl} alt=""
                        className='w-full rounded-[4px]' />
                    </div>
                    <div className="text-[#181512] text-[20px] text-center mt-20 mb-18  line-clamp-1">{item?.title}</div>
                    <div className="text-[#595959] text-[18px] text-center  line-clamp-1">{item?.size}</div>
                    <div className="flex items-center justify-center mt-18 mb-20">
                      <div className="text-[#888] text-[18px]">USD</div>
                      <div className="text-[#888] text-[18px]">{item?.originalPrice}</div>
                      <div className="text-[#888] text-[18px] font-bold ml-4"> USD</div>
                      <div className="text-[#888] text-[18px] font-bold">{item?.currentPrice}</div>
                    </div>
                    <div className="bg-[#6d6e71] rounded-[4px] flex items-center justify-center py-[18px] text-[#fff] text-[18px] cursor-pointer
                    hover:bg-[#000]"
                      onClick={(e) => {
                        // e.stopPropagation();
                        // handleaddCart(item)
                      }}
                    >
                      <img src={require("../../assets/image/icon3_1.png")} className='w-[26px] mr-4' alt="" />
                      加入購物車
                    </div>
                  </div>
                </Fade>
              </SwiperSlide>
            ))
          }
        </Swiper>
        <div>
          <div className={`${swiperIndex === 0 ? 'opacity-20' : 'opacity-60'} cursor-pointer absolute top-[30%] left-[-40px] z-[10] h5:left-[20px]`}
            onClick={() => {
              swiperRef.slideTo(swiperIndex === 0 ? 0 : swiperIndex - 1);
            }}>
            <img src={require('../../assets/image/icon1.png')} alt=""
              className='w-[20px] rotate-[180deg]'
            />
          </div>
          <div className={`${swiperIndex === 1 ? 'opacity-20' : 'opacity-60'} cursor-pointer absolute top-[30%] right-[-40px] z-[10] h5:right-[20px]`}
            onClick={() => {
              swiperRef.slideTo(swiperIndex === 1 ? 1 : swiperIndex + 1);
            }}> 
            <img src={require('../../assets/image/icon1.png')} alt=""
              className='w-[20px] rotate-[0deg]'
            />
          </div>
        </div> 
        <div className="flex justify-center pt-[30px]">
          <div className="bg-[#000] rounded-[4px] inline-block px-[40px] py-[18px] text-[#fff] text-[18px] cursor-pointer
                    hover:bg-[#666]"
            onClick={() => {
              navigate('/category')
            }}>
            更多商品
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;